import useLocale from "hooks/useLocale";
import { DefaultMDXProvider } from "../components/default-mdx-provider";
import * as AboutAr from "../content/ar/about.mdx";
import * as AboutDe from "../content/de/about.mdx";
import * as AboutEn from "../content/en/about.mdx";
import * as AboutEs from "../content/es/about.mdx";
import * as AboutFr from "../content/fr/about.mdx";
import * as AboutRu from "../content/ru/about.mdx";
import * as AboutZh from "../content/zh/about.mdx";

const localeContents = {
  ar: AboutAr,
  de: AboutDe,
  en: AboutEn,
  es: AboutEs,
  fr: AboutFr,
  ru: AboutRu,
  zh: AboutZh,
} as const;

export default function About() {
  const locale = useLocale();
  const { default: Content, frontmatter } = localeContents[locale];

  return (
    <DefaultMDXProvider frontmatter={frontmatter}>
      <Content />
    </DefaultMDXProvider>
  );
}
